import { Clock, DollarSign, FileText, TrendingUp } from "lucide-react";

const iconColorMap: Record<string, { bg: string; text: string; ring: string }> = {
  purple: {
    bg: "bg-brand-purple/12",
    text: "text-brand-purple",
    ring: "ring-brand-purple/25",
  },
  success: {
    bg: "bg-success/12",
    text: "text-success",
    ring: "ring-success/25",
  },
  warning: {
    bg: "bg-warning/15",
    text: "text-warning",
    ring: "ring-warning/25",
  },
  primary: {
    bg: "bg-primary/12",
    text: "text-primary",
    ring: "ring-primary/25",
  },
};

const statDefs = [
  {
    labelKey: "analytics:totalInvoices",
    icon: FileText,
    iconGradient: "purple",
    isCurrency: false,
  },
  {
    labelKey: "analytics:totalPaid",
    icon: DollarSign,
    iconGradient: "success",
    isCurrency: true,
  },
  { labelKey: "analytics:pending", icon: Clock, iconGradient: "warning", isCurrency: false },
  {
    labelKey: "analytics:avgMonthly",
    icon: TrendingUp,
    iconGradient: "primary",
    isCurrency: true,
  },
];

export { iconColorMap, statDefs };
